export default __webpack_public_path__ + "static/media/Interbold.1f011e01.woff2";